import { api } from "./configs/axiosConfigs"

export const InitialStepAPI = {

    get: async (data?: any) => {
        const response = await api.get(
            '/initialStep', { params: { ...data } }
        ).then(response => response.data)
            .catch((error) => {
                return error.response.data
            })
        return response
    },

    create: async (data: any) => {
        const response = await api.post(
            '/initialStep/register', data
        ).then(response => response.data)
            .catch((error) => {
                console.error(error)
                return error.response.data
            })
        return response
    },

    edit: async (id: number, data: any) => {
        const response = await api.patch(
            `/initialStep/${id}`, data
        ).then(response => response.data)
            .catch((error) => {
                return error.response.data
            })
        return response
    },

    delete: async (id: number) => {
        const response = await api.delete(
            `/initialStep/${id}`
        ).then(response => response.data)
            .catch((error) => {
                return error.response.data
            })
        return response
    },

    getDetail: async (data?: any) => {
        const response = await api.get(
            '/initialStep/detail', { params: { ...data } }
        ).then(response => response.data)
            .catch((error) => {
                return error.response.data
            })
        return response
    },

    changeOrder: async (data: any) => {
        const response = await api.post(
            '/initialStep/changeOrder', data
        ).then(response => response.data)
            .catch((error) => {
                console.error(error)
                return error.response.data
            })
        return response
    },
}